<template>
	<Loading v-if="!ready"/>
	<div v-else>
		<h2> {{ name }} </h2>
		<h4> {{ plays.length }} play{{plays.length-1?'s':''}} on record </h4>
		<b-list-group flush>
			<b-list-group-item v-for="p in plays" @click="inspectPlay(p)" class="border-0 pointer">
				{{ p.Play }}
			</b-list-group-item>
		</b-list-group>
	</div>
</template>

<script>
import Vuex from 'vuex'

import Loading from '../Loading.vue'

export default {
	name: 'FeatureAuthor',
	components: { Loading },
	computed: Vuex.mapState({
		name: state => state.featured.author.author.Author,
		plays: state => state.featured.author.plays,
		ready: state => state.featured.author.ready
	}),
	created: function() {
		if(this.$store.state.featured.author.author.id !== this.$route.params.id) {
			this.$store.dispatch('featured/load', {
				type: 'AUTHOR',
				id: this.$route.params.id,
			})
		}
	},
	methods: {
		inspectPlay(rec) {
			this.$store.dispatch('featured/inspect', {
				type: 'PLAY',
				data: rec
			})
			this.$router.push({
				name: 'feature-play',
				params: {
					id: rec.id,
				}
			})
		}
	}
}

</script>
